/*!
 * @license
 * Copyright Squiz Australia Pty Ltd. All Rights Reserved.
 */

import React from 'react';

/**
 * MaterialRounded Switch Access Shortcut (`grey-600`) overlaid with MaterialRounded List (`white`) on a `grey-400` background.
 * @export
 */
export const ICON_SWITCH_ACCESS_SHORTCUT_WITH_LIST = (
  <svg fill="none" height="176" viewBox="0 0 177 176" width="177" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M0 88C0 39.3989 39.3989 0 88 0V0C136.601 0 176 39.3989 176 88V144C176 161.673 161.673 176 144 176H88C39.3989 176 0 136.601 0 88V88Z"
      fill="#F5F5F5"
    />
    <g clipPath="url(#clip0_1143_56141)">
      <path
        className="svg-path-primary"
        d="M63.3003 68.699L53.0003 63.999L63.3003 59.299L68.0003 48.999L72.7003 59.299L83.0003 63.999L72.7003 68.699L68.0003 78.999L63.3003 68.699ZM68.0003 128.999L72.7003 118.699L83.0003 113.999L72.7003 109.299L68.0003 98.999L63.3003 109.299L53.0003 113.999L63.3003 118.699L68.0003 128.999ZM49.8503 85.849L43.0003 88.999L49.8503 92.149L53.0003 98.999L56.1503 92.149L63.0003 88.999L56.1503 85.849L53.0003 78.999L49.8503 85.849ZM123 126.049C123 129.949 118.8 132.299 115.45 130.349C99.0503 120.799 88.0003 102.949 88.0003 83.999C88.0003 70.349 93.4003 57.649 101.75 47.749L92.2503 38.249C90.7003 36.699 91.8003 33.999 94.0503 33.999H120.5C121.9 33.999 123 35.099 123 36.499V62.949C123 65.199 120.3 66.299 118.75 64.699L108.9 54.849C102.2 63.099 98.0003 73.399 98.0003 83.999C98.0003 99.649 107.3 114.049 120.55 121.749C122.05 122.649 123 124.299 123 126.049Z"
        fill="#707070"
      />
    </g>
    <circle cx="132.5" cy="132" fill="#F5F5F5" r="29" />
    <path
      d="M132 107.833C118.636 107.833 107.833 118.636 107.833 132C107.833 145.364 118.636 156.167 132 156.167C145.364 156.167 156.167 145.364 156.167 132C156.167 118.636 145.364 107.833 132 107.833Z"
      fill="#BABABA"
    />
    <rect fill="white" height="4" rx="2" width="4" x="119" y="122" />
    <rect fill="white" height="4" rx="2" width="4" x="119" y="130" />
    <rect fill="white" height="4" rx="2" width="4" x="119" y="138" />
    <rect fill="white" height="4" rx="2" width="18" x="127" y="122" />
    <rect fill="white" height="4" rx="2" width="18" x="127" y="130" />
    <rect fill="white" height="4" rx="2" width="18" x="127" y="138" />
    <defs>
      <clipPath id="clip0_1143_56141">
        <rect fill="white" height="120" transform="translate(28 24)" width="120" />
      </clipPath>
    </defs>
  </svg>
);
